import { useExodus } from '@exodus/headless-react';
import useCurrentEffect from '@exodus/react-hooks/common/useCurrentEffect';
import lodash from 'lodash';
import ms from 'ms';
import { useState } from 'react';
import useFromAsset from './use-from-asset.js';
import useToAsset from './use-to-asset.js';
import useIsExchanging from './use-is-exchanging.js';
const { isEqual } = lodash;
const GET_LIMITS_INTERVAL = ms('10s');
const useExchangeLimits = () => {
    const exodus = useExodus();
    const [limits, setLimits] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [fromAsset] = useFromAsset();
    const [toAsset] = useToAsset();
    const isExchanging = useIsExchanging();
    useCurrentEffect((isCurrent) => {
        if (isExchanging)
            return;
        setLimits(null);
        setIsLoading(true);
        if (fromAsset.ticker === toAsset.ticker)
            return;
        const getLimits = async () => {
            const _limits = await exodus.exchange.getLimits({
                pairId: `${fromAsset.ticker}_${toAsset.ticker}`,
            });
            if (Object.keys(_limits).length === 0) {
                return;
            }
            if (isCurrent()) {
                setLimits((prev) => (isEqual(prev, _limits) ? prev : _limits));
            }
        };
        void getLimits().finally(() => isCurrent() && setIsLoading(false));
        const intervalId = setInterval(getLimits, GET_LIMITS_INTERVAL);
        return () => clearInterval(intervalId);
    }, [exodus.exchange, fromAsset.ticker, isExchanging, toAsset.ticker]);
    if (limits?.ExactIn && !fromAsset.currency.equals(limits.ExactIn.max.unitType)) {
        return [null, true];
    }
    return [limits, isLoading];
};
export default useExchangeLimits;
